module.exports = require("./build/pdfmake.js");
module.exports = require("./build/vfs_fonts.js");


//////////////////
// WEBPACK FOOTER
// pdfmake (bower component)
// module id = 1480
// module chunks = 0